import { IconNames } from '@dixa/lib-shared-habla';
import { UserType } from 'lib-shared-types-api';

type UserTypeAssets = {
  /** Icon representing the user type. */
  icon: IconNames;
  /** Pretty name of the user type. */
  prettyName: string;
  /** Pretty name of the user type in plural. */
  prettyNamePlural: string;
};

/** Various assets of a user type. */
export const userTypeAssets: Readonly<Record<UserType, UserTypeAssets>> = {
  bot: {
    icon: 'chat-bot',
    prettyName: 'Bot',
    prettyNamePlural: 'Bots',
  },
  contact: {
    icon: 'id-card',
    prettyName: 'Contact',
    prettyNamePlural: 'Contacts',
  },
  member: {
    icon: 'headset',
    prettyName: 'Agent',
    prettyNamePlural: 'Agents',
  },
};
